import React from 'react';
import { Tool } from '@/types/tool';
import { useLanguage } from '@/context/LanguageContext';
import { TranslationKey } from '@/translations/translations';

interface ToolTooltipProps {
  toolId: string;
  children: React.ReactNode;
  className?: string;
}

// Import tools data - we'll create this next
import { getToolById } from '@/data/tools';

const ToolTooltip: React.FC<ToolTooltipProps> = ({ toolId, children, className = '' }) => {
  const tool = getToolById(toolId);
  const { t } = useLanguage();

  if (!tool) {
    return <>{children}</>;
  }

  return (
    <div className={`group relative inline-block ${className}`}>
      {children}

      {/* Tooltip content */}
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-popover border border-border rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus-within:opacity-100 group-focus-within:visible transition-all duration-200 z-50 w-64">
        <div className="text-sm">
          <h4 className="font-semibold text-foreground mb-1">{t(tool.tooltip.title as unknown as TranslationKey)}</h4>
          <p className="text-muted-foreground text-xs mb-2">{t(tool.tooltip.description as unknown as TranslationKey)}</p>

          {tool.tooltip.quickStats && (
            <div className="flex gap-3 text-xs text-muted-foreground border-t pt-2">
              {tool.tooltip.quickStats.stars !== undefined && (
                <span>⭐ {tool.tooltip.quickStats.stars}</span>
              )}
              {tool.tooltip.quickStats.forks !== undefined && (
                <span>🔱 {tool.tooltip.quickStats.forks}</span>
              )}
              {tool.tooltip.quickStats.lastUpdated && (
                <span>📅 {tool.tooltip.quickStats.lastUpdated}</span>
              )}
            </div>
          )}
        </div>

        {/* Arrow */}
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
          <div className="w-2 h-2 bg-popover border-r border-b border-border transform rotate-45"></div>
        </div>
      </div>
    </div>
  );
};

export default ToolTooltip;
